<template>
  <div class="icode">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "layout",
};
</script>

<style lang="scss">
.icode {
  width: 100%;
  background: url("../../../static/query/bg.jpg") no-repeat;
  background-size: 100%;
  overflow: hidden;
}
</style>
